import { useState } from 'react';
import { Tooltip, IconButton, Box } from '@mui/material';
import { PropTypes } from 'prop-types';
// import { webalize } from 'webalize';
// import { useReactToPrint } from 'react-to-print';
// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';
// import jsPDF from 'jspdf';
import useLocales from '../../../hooks/useLocales';
import Iconify from '../../Iconify';
import ShareModal from './ShareModal';
// import Heart from '../Cards/Heart';
import DetailHeart from './DetailHearth';
import { GAEvent } from '../../GoogleAnalytics';
// import { dispatch } from '../../../redux/store';
// import { startLoading, stopLoading } from '../../../redux/slices/articles';

DetailsTooltips.propTypes = {
  printInstance: PropTypes.object,
  // printRef: PropTypes.object,
  title: PropTypes.string,
  heartAction: PropTypes.func,
  favorite: PropTypes.bool,
  size: PropTypes.number,
  licence: PropTypes.number,
};

export default function DetailsTooltips(props) {
  const { printInstance, /* printRef, */ title, heartAction, size, favorite, licence } = props;
  const { translate } = useLocales();
  const [showShareModal, setShowShareModal] = useState(false);

  /* const handlePrint = useReactToPrint({
    content: () => refProp.current,
    onBeforeGetContent: () => {
      // refProp.current.style.marginTop = `-${HEADER.MAIN_DESKTOP_HEIGHT + 16 + 50}px`;
    },
  });

  const handleDownloadPdf = async () => {
    dispatch(startLoading());
    window.scrollTo(0, 0);
    const element = refProp.current;

    html2canvas(element, {
      scale: 1,
      useCORS: true,
      scrollX: 0,
      scrollY: -window.scrollY,
      logging: true,
      dpi: window.devicePixelRatio * 300,
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png', 0.01);
      // eslint-disable-next-line new-cap
      const imgWidth = 210;
      const pageHeight = 310;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      // eslint-disable-next-line new-cap
      const doc = new jsPDF('pt', 'mm');
      let position = 0;
      doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight + 35);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight + 35);
        heightLeft -= pageHeight;
      }
      doc.save(`${webalize(title)}.pdf`);

      dispatch(stopLoading());

      // for test
      // const pdfBlob = pdf.output('blob');
      // const pdfUrl = URL.createObjectURL(pdfBlob);

      // // Open PDF in new tab
      // window.open(pdfUrl, '_blank');
    });
  }; */

  const heart = () => {
    heartAction();
  };

  const handlePrint = () => {
    GAEvent('Print', 'Print Article', `${title}`);
    window.open(printInstance.url, '_blank');
  };

  const handleDownloadPdf = () => {
    const url = window.URL.createObjectURL(printInstance.blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${title}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  return (
    <Box className="hidden-print">
      <DetailHeart
        heartAction={
          (/* e */) => {
            heart(/* e */);
          }
        }
        name={props}
        favorite={favorite}
      />
      <Tooltip
        title={translate('default.share')}
        placement="top"
        enterTouchDelay={0}
        arrow
        PopperProps={{
          style: { padding: '8px' }, // Add padding to the Popper element
        }}
      >
        <span>
          <IconButton
            aria-label="share"
            disabled={licence === 0}
            sx={{ color: (theme) => theme.palette.text.primary }}
            onClick={() => licence !== 0 && setShowShareModal(true)}
          >
            <Iconify icon="ep:share" width={size} height={size} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        title={
          printInstance.loading === true || printInstance?.blob?.size < 8000
            ? translate('objects.loading')
            : translate('default.print')
        }
        placement="top"
        enterTouchDelay={0}
        arrow
        PopperProps={{
          style: { padding: '8px' }, // Add padding to the Popper element
        }}
      >
        <span>
          <IconButton
            aria-label="print"
            disabled={licence === 0 || printInstance.loading === true || printInstance?.blob?.size < 8000}
            sx={{ color: (theme) => theme.palette.text.primary }}
            onClick={() => licence !== 0 && printInstance.loading === false && handlePrint()}
          >
            <Iconify icon="fluent:print-20-filled" width={size} height={size} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip
        title={
          printInstance.loading === true || printInstance?.blob?.size < 8000
            ? translate('objects.loading')
            : translate('default.download')
        }
        placement="top"
        enterTouchDelay={0}
        arrow
        PopperProps={{
          style: { padding: '8px' }, // Add padding to the Popper element
        }}
      >
        <span>
          <IconButton
            aria-label="download"
            disabled={printInstance.loading === true || printInstance?.blob?.size < 8000}
            sx={{ color: (theme) => theme.palette.text.primary }}
            onClick={handleDownloadPdf}
          >
            <Iconify icon="akar-icons:cloud-download" width={size} height={size} />
          </IconButton>
        </span>
      </Tooltip>
      <ShareModal
        open={showShareModal}
        title={title}
        onClose={() => {
          setShowShareModal(false);
        }}
      />
    </Box>
  );
}
